<ng-template>
  <ng-container [ngSwitch]="icon.type">
    <mat-icon *ngSwitchCase="iconType.SVG" [svgIcon]="icon.name"></mat-icon>
    <mat-icon *ngSwitchDefault>{{ icon.name }}</mat-icon>
  </ng-container>
</ng-template>